import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { adminData } = useSelector((state) => state.admin);

  // token check (Redux OR localStorage)
  const isAuthenticated =
    adminData?.acessToken ||
    JSON.parse(localStorage.getItem('admin'))?.acessToken;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
